export function captureAttribution() {
  try {
    const p = new URLSearchParams(window.location.search);
    const utm = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((k) => {
      if (p.get(k)) utm[k] = p.get(k);
    });
    return {
      utm,
      landing_page: window.location.pathname + window.location.search,
      referrer: document.referrer || "",
    };
  } catch {
    return { utm: {}, landing_page: "", referrer: "" };
  }
}
